<script setup lang="ts">
import ForgotPasswordForm from '@/v2/shared/components/auth/ForgotPasswordForm.vue'
import AuthLayout from '@/v2/shared/layouts/auth/AuthLayout.vue'
import { Link } from '@inertiajs/vue3'
import { route } from 'ziggy-js'

defineProps<{
    status?: string
}>()
</script>

<template>
    <AuthLayout title="Forgot Password">
        <template #header-action>
            Remember your password?
            <Link
                :href="route('login')"
                class="underline decoration-from-font underline-offset-2"
            >
                Log in
            </Link>
        </template>

        <ForgotPasswordForm :status="status" />
    </AuthLayout>
</template>
